module.exports = __webpack_public_path__ + "static/french_circle_1-9e4a4d8b86ea09e3bb98ff72413732be.svg";